import React, { useState, useEffect } from "react";
import FileBase64 from "../../components/Upload/UploadFile";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import { Card, Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import PublishIcon from "@mui/icons-material/Publish";
import { uploadSampleFileOfDealerDsrLimitapi } from "../../redux/actions/uploadSampleFileOfDealerDsrLimitAction";
import { dealerSampleFileList } from '../../redux/actions/dealerSampleFileAction'
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { FileExcelFilled, FilePdfFilled } from "@ant-design/icons";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const DealerUploadDsrLimit = () => {
	const classes = useStyles();
	const [uploadFile, setUploadFile] = useState("");
	const dispatch = useDispatch();
	// const [limitFile, setLimitFile] = useState("");
	// const [limitFileName, setLimitFileName] = useState("");

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [openUploadModal, setOpenUploadModal] = React.useState(false);

	const [uploadSampleFileStatus, setUploadSampleFileStatus] = useState(false);
	const [uploadSampleFileArray, setUploadSampleFileArray] = useState([]);
	const [
		downloadDealerSampleFileStatus,
		setDownloadDealerSampleFileStatus
	] = useState(false);



	const handleChange = ({ target: { name, value } }) => {
		if (name === "uploadFile") {
			setUploadFile(value);
		}
	};

	const handleNoticationClose = () => {

		setOpenUploadModal(false)
	};
	const uploadSampleFileOfDealerDsrLimitRes = useSelector(
		({ dealerUploadDsrLimit }) => dealerUploadDsrLimit
	);
	const downloadSampleFileDealerRes = useSelector(
		({ dealerSampleFileLists }) => dealerSampleFileLists
	)


	const downloadSampleFileDealerLimits = () => {
		setDownloadDealerSampleFileStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
			}

		};
		dispatch(
			dealerSampleFileList(req, authToken)
		)
	}

	useEffect(() => {
		if (downloadDealerSampleFileStatus) {
			if (downloadSampleFileDealerRes.data.status == "success") {
				var link = document.createElement("a");
				link.download = downloadSampleFileDealerRes.data.fileName;
				link.href =
					"data:application/octet-stream;base64," +
					downloadSampleFileDealerRes.data.fileDate.split(`,`)[1];
				link.click();
			}
			// if (downloadSampleFileOfCurrencyRateRes.data.status == "Failed") {

			// }
		}
	}, [downloadSampleFileDealerRes.data.status]);


	const uploadSampleFileOfDealerDsrLimits = () => {
		setUploadSampleFileStatus(true);
		const fd = new FormData();
		const downloadSampleFileOfDsrUploadReq = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,

				file: uploadFile.split(",")[1]
			}
		};

		return dispatch(
			uploadSampleFileOfDealerDsrLimitapi(
				downloadSampleFileOfDsrUploadReq,
				authToken
			)
		);
	};
	const UploadFileFunc = () => {
		if (uploadSampleFileStatus) {
			if (uploadSampleFileOfDealerDsrLimitRes.data.status == "success") {
				setUploadSampleFileArray(uploadSampleFileOfDealerDsrLimitRes.data);
				setOpenUploadModal(true)
			}
			if (uploadSampleFileOfDealerDsrLimitRes.data.status == "failed") {
				setUploadSampleFileArray(uploadSampleFileOfDealerDsrLimitRes.data);
				setOpenUploadModal(true)
			}

		}
	}
	useEffect(() => {
		UploadFileFunc();
	}, [uploadSampleFileOfDealerDsrLimitRes.data.status]);

	// useEffect(() => {
	// 	if (uploadSampleFileStatus) {
	// 		if (uploadSampleFileOfDealerDsrLimitRes.data.status == "success") {
	// 			swalWithBootstrapButtons.fire({
	// 				type: "success",
	// 				title: "Upload File Successfully"
	// 			});
	// 		}
	// 		if (uploadSampleFileOfDealerDsrLimitRes.data.status == "failed") {
	// 			swalWithBootstrapButtons.fire({
	// 				type: "error",
	// 				title: " File  is Not Upload"
	// 			});
	// 			if (
	// 				uploadSampleFileOfDealerDsrLimitRes.data.description ==
	// 				"session out"
	// 			) {
	// 				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 			if (
	// 				uploadSampleFileOfDealerDsrLimitRes.data.description == "Authorization failed"
	// 			) {
	// 				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 		}
	// 		if (uploadSampleFileOfDealerDsrLimitRes.data.status == "Failed") {
	// 			swalWithBootstrapButtons.fire({
	// 				type: "error",
	// 				title: " File  is Not Upload"
	// 			});
	// 			if (
	// 				uploadSampleFileOfDealerDsrLimitRes.data.description ==
	// 				"session out"
	// 			) {
	// 				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 			if (
	// 				uploadSampleFileOfDealerDsrLimitRes.data.description == "Authorization failed"
	// 			) {
	// 				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 			}
	// 		}
	// 	}
	// }, [uploadSampleFileOfDealerDsrLimitRes.data.status]);


	const [UploadFileName, setUploadFileName] = useState("");

	const handleAttachmentsDoc = (e, uploadFile) => {
		if (uploadFile == "uploadFile") {
			setUploadFile(e.base64);
			setUploadFileName(e.name);
			setBtnDisable(false);
		}
	};

	const [btnDisable, setBtnDisable] = useState(true);

	return (
		<>
			<Layout>
				<BackButton />

				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem", textAlign: "center" }}
					>
						<Grid
							className="d-flex align-items-center justify-content-center"
							item
							xs={12}
							sm={12}
							md={4}
							lg={4}
						>
							<p style={{ fontSize: "18px", margin: "0" }}>Select Rate File </p>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							{/* <input
                name="uploadFile"
                value={uploadFile}
                className="my-2"
                type="file"
                placeholder="Browse"
                onChange={handleChange}
              /> */}

							<FileBase64
								multiple={false}
								name={false}
								id="documentGuard"
								accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
								onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
								showUploadList={false}
								value={UploadFileName}
							/>
							{UploadFileName ? UploadFileName : ""}

							{/* <Button
                style={{
                  marginLeft: "0.2rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
              >
                Browse
              </Button> */}
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							<Button
								style={{
									marginLeft: "0.2rem",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								className="riskRuleButton"
								// onClick={downloadSampleFileOfDsrUpload}
								onClick={downloadSampleFileDealerLimits}
								endIcon={
									<FileExcelFilled
										style={{ color: "#fff", fontSize: "16px" }}
									/>
								}
							>
								Sample Limit File:
							</Button>
						</Grid>
					</Grid>
					<Grid
						container
						style={{
							padding: "25px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={4} className="text-center">
							{btnDisable ? (
								<Button
									style={{
										backgroundColor: "#80dcfa",
										color: "white"
									}}
									variant="contained"
									className="riskRuleButton"
									onClick={uploadSampleFileOfDealerDsrLimits}
									endIcon={<PublishIcon />}
									disabled={btnDisable}
								>
									Upload
								</Button>
							) : (
								<Button
									style={{
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									className="riskRuleButton"
									onClick={uploadSampleFileOfDealerDsrLimits}
									endIcon={<PublishIcon />}
									disabled={btnDisable}
								>
									Upload
								</Button>
							)}

							{/* <Button  
                style={{
                  backgroundColor: "#00b9f5", 
                  color: "white",
                }}
                variant="contained"
                className="riskRuleButton"
                onClick={uploadSampleFileOfCurrencyRates}
                endIcon={<PublishIcon />}
                disabled={btnDisable}
              // disabled="true"
              >
                Upload
              </Button> */}
						</Grid>
					</Grid>
				</Card>

				{/* <div style={{ marginTop: "1.5rem", display: 'flex', alignItems: 'center' }}>
                    {" "}
                    <Typography
                        variant="body1"
                        align="left"
                        gutterBottom={true}
                        style={{ color: "#4f6c8d", marginRight: '20px' }}
                    >
                        Select limit file:
                    </Typography>
            
                    <FileBase64

                        multiple={false}
                        name={false}
                        id="documentGuard"

                        accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
                        onDone={(e) => handleAttachmentsDoc(e, "limitFile")}
                        showUploadList={false}
                        value={limitFileName}
                    />
                    {limitFileName ? limitFileName : ""}
                </div> */}
			</Layout>
			{uploadSampleFileArray.status == "success" && (
				<div>
					<Dialog open={openUploadModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{uploadSampleFileArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{uploadSampleFileArray.status == "failed" && (
				<div>
					<Dialog open={openUploadModal} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{uploadSampleFileArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default DealerUploadDsrLimit;
